import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - start earning banner';

export default {
  ...defineTracking({
    navMenu: {
      category,
      action: 'click',
      label: '{id} nav menu',
      description:
        'This event is triggered when a user clicks a nav menu item. ' +
        '{id} represents the id of the nav menu item the user clicked.',
    },
    navSwipeNext: {
      category,
      action: 'swipe',
      label: 'next',
      description: 'This event is triggered when a user swipes to navigate to the next card.',
    },
    navSwipePrevious: {
      category,
      action: 'swipe',
      label: 'previous',
      description: 'This event is triggered when a user swipes to navigate to the previous card.',
    },
  }),
};
